module.exports = __webpack_public_path__ + "img/icon_xieyi.d5675007.png";